import { isMobile } from "../helpers/isMobile";

export const MAX_USER_INACTIVE_STATE_DURATION = 900000;


export const GAME_SPEED_TYPES = {
  standard: 'standard',
  fast: 'fast',
  turbo: 'turbo',
};


export const stageOptions = isMobile()
  ? { transparent: true, backgroundAlpha: 0, resolution: 2 }
  : {
    resolution: 1.5,
    antialias: false,
    autoDensity: true,
    transparent: true,
    sharedTicker: true,
    forceCanvas: false,
    powerPreference: 'high-performance',
  }
